import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { patchCancelForeignCurrency } from '@/api/fx';
import { PatchCancelForeignCurrencyBody } from '@/types/fx.type';
import { useAppDispatch } from './useReduxHooks';
import { updateLoading } from '@/store/loading.store';

interface UsePatchCancelForeignCurrencyProps {
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

export const usePatchCancelForeignCurrency = ({
  onSuccess,
  onError,
}: UsePatchCancelForeignCurrencyProps = {}) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isLoading, isError, error, isSuccess, data } =
    useMutation<number, AxiosError, PatchCancelForeignCurrencyBody>(
      (payload) => {
        dispatch(updateLoading({ isLoading: true }));
        return patchCancelForeignCurrency(payload);
      },
      {
        onSuccess: () => {
          // 외화 수납 취소 후 외화 수납 내역 캐시 무효화
          queryClient.invalidateQueries('foreignCurrencyHistory');

          if (onSuccess) {
            onSuccess();
          }

          dispatch(updateLoading({ isLoading: false }));
        },
        onError: (error) => {
          console.error('Foreign currency cancel error:', error);

          if (onError) {
            onError(error);
          }

          dispatch(updateLoading({ isLoading: false }));
        },
        retry: 0,
      },
    );

  return {
    cancelForeignCurrency: mutate,
    cancelForeignCurrencyAsync: mutateAsync,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
  };
};
